import { render } from "./GridSelectEditorNeo.vue?vue&type=template&id=2796b6f2"
import script from "./GridSelectEditorNeo.vue?vue&type=script&lang=js"
export * from "./GridSelectEditorNeo.vue?vue&type=script&lang=js"

import "./GridSelectEditorNeo.vue?vue&type=style&index=0&id=2796b6f2&lang=css"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__